import {createApp} from 'vue'
import DeleteProfileFlow from './DeleteProfileFlow'

const el = '.kb-component--delete-profile-flow'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DeleteProfileFlowDOM)=>{

            const props = {
                userProfileId: DeleteProfileFlowDOM.dataset.userProfileId,
                userData: JSON.parse(DeleteProfileFlowDOM.dataset.userData),
            }

            const component = createApp(DeleteProfileFlow, props).use(Store)
            component.mount(DeleteProfileFlowDOM)
        })
    }
}